import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  catchError,
  finalize,
  map,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { MobileNumberService } from 'src/app/core/services/mobile-number.service';
import { AppShowForm } from 'src/app/core/types/app-show-form.type';
import {
  ContactsWithPaginationDto,
  CustomResult,
  CustomResultOfPaginatedListOfContactsWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfContactsWithPaginationDto,
  PhonebookDto,
  PhonebookTypes,
} from '../../../core/api/models';
import { ClaimsService, ExcelService } from '../../../core/api/services';
import { ContactsService } from '../../../core/api/services/contacts.service';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexModule } from '../../shared/base';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { CustomField } from './../../../core/api/models/custom-field';
import { PhonebookCustomFieldsService } from './../../../core/api/services/phonebook-custom-fields.service';
import { ContactsFormComponent } from './contacts-form/contacts-form.component';
import { ContactsImportFromXlsxComponent } from './contacts-import-from-xlsx/contacts-import-from-xlsx.component';
import { ContactsNumberListForm } from './contacts-number-list-form/contacts-number-list-form.component';
import { CreateContactsExcelDialogComponent } from './create-contacts-excel/create-contacts-excel-dialog.component';
import { DeleteContactsFromPhonebooksComponent } from './delete-contacts-form-phonebooks/delete-contacts-form-phonebooks.component';
import { SearchNumberComponent } from './search-number/search-number.component';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styles: [
        `
      :host-context(.dark) {
        .text-vertical {
          color: white !important;
        }
      }
    `,
    ],
    imports: [
        BaseIndexModule,
        ContactsFormComponent,
        ContactsNumberListForm,
        ContactsImportFromXlsxComponent
    ]
})
export class ContactsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.contacts;
  protected currentService = inject(ContactsService);
  createGetApiMethodName: string = this.currentService.contactsCreateGet.name;
  modelWithPagination$: Observable<PaginatedListOfContactsWithPaginationDto>;
  items$: Observable<Array<ContactsWithPaginationDto>>;
  selectedContacts: ContactsWithPaginationDto[] = [];

  @Output('isShowContactsForm') output_isShowContactsForm =
    new EventEmitter<boolean>();
  @Output('updatePhonebookTable') output_updatePhonebookTable =
    new EventEmitter<boolean>();
  @Output('showContactAudit') output_showContactAudit =
    new EventEmitter<boolean>();
  @Output('contactCount') output_contactCount = new EventEmitter<number>();
  @Input() selectedPhonebook: PhonebookDto;

  phonebookId: number;
  phonebookTitle: string;
  phonebookType: PhonebookTypes;
  customFields: CustomField[];
  contactCount: number = 0;

  isShowContactsNumberListForm: boolean = false;
  isShowContactsImportFromXlsx: boolean = false;

  downloadLoading: boolean = false;

  get PhonebookTypes() {
    return PhonebookTypes;
  }
  CreateTypeEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(
    public claimsService: ClaimsService,
    private dynamicTabService: DynamicTabService,
    protected excelFileService: ExcelService,

    private phonebookCustomFieldsService: PhonebookCustomFieldsService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.pageSizes = [30, 50, 70, 100];
      // this.showForm('update',3);

      // this.paginationModel.pageSize = 30;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('CreateType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.CreateTypeEnumValues = values));
  }

  //برای اینکه گزارش گیری مخاطبین در صفحه ی کامل باز شود
  onShowAuditPage() {
    this.output_showContactAudit.emit(true);
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
        wrap: true,
      },
      {
        title: this.localizer.firstName,
        name: 'firstName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.lastName,
        name: 'lastName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.mobile,
        name: 'cellPhone',
        hasSearch: true,
        wrap: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}telephone`,
        name: 'telephone',
        hasSearch: true,
        wrap: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}createType`,
        name: 'createType',
        hasSearch: true,
        type: 'enum',
        noSorting: true,
        enumName: 'CreateType',
      },
      {
        title: 'common.dateExit',
        name: 'created',
        hasSearch: false,
        type: 'dateTime',
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'createdAt',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  setDefaultTableSort() {
    this.sortObject.push({ columnName: 'createdAt', sort: 1 });
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (
        changes['selectedPhonebook'] &&
        this.phonebookId != this.selectedPhonebook.id
      ) {
        this.isShowContactsNumberListForm = false;
        this.isShowContactsImportFromXlsx = false;
        this.phonebookId = this.selectedPhonebook.id;
        this.phonebookTitle = this.selectedPhonebook.name;
        this.phonebookType = this.selectedPhonebook.phonebookTypes;
        this.selectedIds = [];
        this.getTableData();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getTableData() {
    if (this.phonebookId == 0 || this.phonebookId == undefined) return;
    super.getTableData();
  }

  //removed takeUntil
  override bindTableData() {
    if (this.isBindTableData) return;
    this.isBindTableData = true;
    this.tableDataSubject$
      .pipe(
        switchMap((res) => {
          this.pageConfig.loading = true;
          return this.getPaginationApi().pipe(
            map((res) => res.data),
            tap((result) => {
              this.modelWithPagination$ = of(result);
            }),
            finalize(() => (this.pageConfig.loading = false)),
            catchError((error) => {
              this.pageConfig.isEmpty = false;
              this.pageConfig.hasError = true;
              return error;
            }),
            finalize(() => {
              this.pageConfig.loading = false;
            })
          );
        })
      )
      .subscribe({
        next: (res: any) => {
          this.checkSelectedItems();
          this.getPaginationData(res);
          this.items = res.items;
          this.items$ = of(this.items);
          res.items?.length > 0
            ? (this.pageConfig.isEmpty = false)
            : (this.pageConfig.isEmpty = true);
          this.pageConfig.loading = false;
        },
        error: (error) => {
          ConsoleService.error('error', error);
          this.isBindTableData = false;
        },
      });
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfContactsWithPaginationDto> {
    return this.currentService
      .contactsGetContactsWithPagination({
        body: {
          ...this.getBaseModelWithPaginationParams(),
          phonebookId: this.phonebookId,
        },
      })
      .pipe(
        tap((items) => {
          this.contactCount = items.data.totalCount;
          this.emitContactCount();
        })
      );
  }

  //Get ById
  baseGetByIdApi(id: string): void {
    this.unSubs();

    this.pageConfig.loading = true;
    this.formPageConfig.isEditMode = true;
    this.formPageConfig.editId = id;

    this.currentService
      .contactsUpdateGet({ ContactId: id, PhonebookId: this.phonebookId })
      .pipe(this.basePipeOperators())
      .subscribe(
        (response) => {
          this.formPageConfig.editData = response?.data;
          this.getCustomFieldsByPhonebookId(this.selectedPhonebook.id);
        },
        (error) => ConsoleService.error('error', error),
        () => (this.pageConfig.loading = false)
      );
  }

  //Get phonebook customFields
  getCustomFieldsByPhonebookId(phonebookId: number) {
    this.pageConfig.loading = true;
    this.phonebookCustomFieldsService
      .phonebookCustomFieldsGetCustomFieldByPhonebook({
        phonebookId: phonebookId,
      })
      .pipe(this.basePipeOperators())
      .subscribe(
        (response) => {
          this.customFields = response.data;
          this.phonebookId = this.selectedPhonebook.id;
          this.phonebookTitle = this.selectedPhonebook.name;

          this.pageConfig.isVisibleForm = true;
          this.emitIsShowContactsForm();
        },
        (error) => ConsoleService.error('error', error),
        () => (this.pageConfig.loading = false)
      );
  }

  //Delete
  baseDeleteApi(id: string) {
    this.pageConfig.loading = true;

    this.currentService
      .contactsDelete({ body: { id: id, phonebookId: this.phonebookId } })
      .pipe(
        this.basePipeOperators(),
        tap((res) => {
          if (res.isSucceed) {
            this.emitUpdatePhonebookTable();
          }
        })
      )
      .subscribe(this.baseObserver);
  }

  // Create Get
  contactsCreateGetApi() {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .contactsCreateGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          this.formPageConfig.isEditMode = false;
          this.getCustomFieldsByPhonebookId(this.phonebookId);
        }
      });
  }

  // Create Get
  contactFromNumbersListGetApi() {
    this.unSubs();

    this.pageConfig.loading = true;
    this.currentService
      .contactsCreateContactFromNumbersListGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          this.phonebookId = this.selectedPhonebook.id;
          this.phonebookTitle = this.selectedPhonebook.name;
          this.isShowContactsNumberListForm = true;
        }
        this.emitIsShowContactsNumberListForm();
      });
  }

  // Create Get
  contactsFromListByJsonLzStringPost() {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .contactsCreateContactsFromFileGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          this.pageConfig.loading = true;
          this.phonebookCustomFieldsService
            .phonebookCustomFieldsGetCustomFieldByPhonebook({
              phonebookId: this.phonebookId,
            })
            .pipe(this.basePipeOperators())
            .subscribe(
              (response) => {
                this.customFields = response.data;
                this.phonebookId = this.selectedPhonebook.id;
                this.phonebookTitle = this.selectedPhonebook.name;
                this.isShowContactsImportFromXlsx = true;
                this.emitIsShowImportFromExcelForm();
              },
              (error) => ConsoleService.error('error', error),
              () => (this.pageConfig.loading = false)
            );
        }
      });
  }

  //Download
  downloadContactsGetApi() {
    this.excelFileService
      .excelCreateContactsExcelByPhonebookIdGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: 'common.downloadExcel',
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
            phonebookId: this.phonebookId,
          };

          const modalResult = this.dialogService.openModal({
            component: CreateContactsExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  downloadContactsPostApi() {
    this.unSubs();
    this.downloadLoading = true;

    this.excelFileService
      .excelCreateContactsExcelByPhonebookIdPost({
        body: {
          comparisonObjects: this.comparisonObjects,
          orders: this.sortObject,
          phonebookId: this.phonebookId,
        },
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.downloadLoading = false))
      )
      .subscribe((file) => {
        //  UtilService.downloadFile(file.detail);
      });
  }

  deleteContactsApi(ids: string[]) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.currentService
      .contactsDeleteContacts({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => {
          this.selectedIds = [];
          this.selectedContacts = [];
        })
      )
      .subscribe(
        (result: CustomResult) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.selectedIds = [];
            this.selectedContacts = [];
            this.getTableData();

            // this.deleteGroupItemsLocally();
            // this.getItems();
            this.emitUpdatePhonebookTable();
          }
        },
        (error) => {
          ConsoleService.error('error', error);
          this.selectedIds = [];
          this.selectedContacts = [];
        }
      );
  }

  deleteAllContactsApi(phonebookId: number) {
    this.unSubs();
    this.currentService
      .contactsDeleteAllContactsByPhonebookId({ phonebookId: phonebookId })
      .pipe(this.basePipeOperators())
      .subscribe((result: CustomResult) => {
        this.apiNotificationService.notifyMessage({ result });
        if (result.isSucceed) {
          this.selectedIds = [];
          this.getTableData();
          this.emitUpdatePhonebookTable();
        }
      });
    this.pageConfig.loading = true;
  }

  deleteContactFromAllPhonebooksApi(
    contactIds: string[],
    phonebookIds: number[],
    emptyTheSelectedIds?: boolean
  ) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .contactsDeleteContactFromAllPhonebooks({
        body: { contactIds: contactIds, phonebookIds: phonebookIds },
      })
      .pipe(this.basePipeOperators())
      .subscribe((result: CustomResult) => {
        this.apiNotificationService.notifyMessage({ result });
        if (result.isSucceed) {
          if (emptyTheSelectedIds) this.selectedIds = [];
          this.getTableData();
          this.emitUpdatePhonebookTable();
        }
      });
  }

  //#endregion

  //#region Contacts NumberList

  onShowContactsNumberList() {
    this.closeAllCreateForm();
    this.contactFromNumbersListGetApi();
  }

  getContactsNumberListFormResponse(event) {
    if (event) {
      this.getTableData();
      this.emitUpdatePhonebookTable();
    }

    this.isShowContactsNumberListForm = !this.isShowContactsNumberListForm;
  }

  //#endregion

  //#region Import Contact's from xlsx
  onShowImportContactsFromXlsx() {
    this.closeAllCreateForm();
    this.contactsFromListByJsonLzStringPost();
  }

  getImportContactsFromXlsxResponse(event) {
    try {
      if (event) {
        this.getTableData();
        this.emitUpdatePhonebookTable();
      }

      this.isShowContactsImportFromXlsx = !this.isShowContactsImportFromXlsx;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
  //#endregion

  //#region group Deletion

  callGroupDeletion() {
    this.deleteContactsApi(this.selectedIds);
  }

  deleteAllContactsConfirmation(phonebookId: number) {
    const dialogResult = this.getConfirmDialog({
      title: 'messages.deleteAllContactConfirmation',
      isConfirmDelete: true,
      wordBreak: false,
      confirmByWritingText: true,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.deleteAllContactsApi(phonebookId);
          this.cd.detectChanges();
        }
      });
  }

  //#endregion

  onSearchContacts() {
    const modalResult = this.dialogService.openModal({
      component: SearchNumberComponent,
    });

    const sub = modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          MobileNumberService.mobileNumber = res;
          this.dynamicTabService.setNewTab('');
          this.dynamicTabService.setNewTab('contactsByCellPhone');
          this.dynamicTabService.setActiveTab('contactsByCellPhone');
          this.cd.detectChanges();
        }
      });
  }

  emitIsShowContactsForm() {
    this.output_isShowContactsForm.emit(this.pageConfig?.isVisibleForm);
  }

  emitIsShowImportFromExcelForm() {
    this.output_isShowContactsForm.emit(this.isShowContactsImportFromXlsx);
  }

  emitIsShowContactsNumberListForm() {
    this.output_isShowContactsForm.emit(this.isShowContactsNumberListForm);
  }

  showForm(type: AppShowForm, id?: string) {
    this.closeAllCreateForm();

    if (type === 'create') this.contactsCreateGetApi();

    if (type === 'update') this.baseGetByIdApi(id);
  }

  closeAllCreateForm() {
    this.isShowContactsImportFromXlsx = false;
    this.isShowContactsNumberListForm = false;
    this.pageConfig.isVisibleForm = false;
  }

  emitContactCount() {
    this.output_contactCount.emit(this.contactCount);
  }

  onDelete(id: any, content: any) {
    let dialogResult = this.dialogService.confirmDialog({
      content: content,
      isConfirmDelete: true,
      isShowCheckBox: true,
      checkBoxLabel: 'messages.removeContactFromAllPhonebook',
    });
    dialogResult.afterClosed().subscribe((result) => {
      if (result?.isChecked) this.deleteContactFromAllPhonebooksApi([id], []);
      else if (result) this.baseDeleteApi(id);
    });
  }

  onShowDeleteContactsFromAllPhonebooks(contactId: string) {
    const modalResult = this.dialogService.openModal({
      component: DeleteContactsFromPhonebooksComponent,
      data: {
        currentPhonebookId: this.selectedPhonebook.id,
        contactId: contactId,
      },
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((phonebooks) => {
        if (phonebooks)
          this.deleteContactFromAllPhonebooksApi([contactId], phonebooks);
      });
  }

  getFormResponse(isSuccess) {
    if (isSuccess) {
      this.getTableData();
      this.emitUpdatePhonebookTable();
    }

    this.pageConfig.isVisibleForm = false;
    this.unSubs();
  }

  emitUpdatePhonebookTable() {
    this.output_updatePhonebookTable.emit(true);
  }

  onAddSelectedIdAndCellPhone(event, item: ContactsWithPaginationDto, element) {
    try {
      const checkBoxAllElement =
        this.elementRef.nativeElement.querySelectorAll(`.select-all`);

      let checked = event?.target?.checked;
      if (!item) return;

      if (checked) {
        //add
        this.isSelectAll(checkBoxAllElement);
        if (this.selectedIds?.find((id) => id === item.id)) return;
        this.selectedIds?.push(item.id);
        this.selectedContacts?.push(item);
        (element as HTMLElement).classList.add('row-active');
      } else {
        //remove
        const id = this.selectedIds?.findIndex((id) => id === item.id);
        if (id != -1) {
          this.selectedIds?.splice(id, 1);
          this.selectedContacts?.splice(id, 1);
        }

        (element as HTMLElement).classList.remove('row-active');
        if ((checkBoxAllElement[0] as HTMLInputElement).checked)
          this.unCheckSelectAll();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onGroupDeletion() {
    if (this.selectedContacts?.length === 0) return;
    this.groupDeletionConfirmation();
  }

  groupDeletionConfirmation() {
    try {
      let cellPhones: string[] = this.selectedContacts.map(
        (item) => item.cellPhone
      );

      const dialogResult = this.getConfirmDialog({
        title: 'messages.groupDeletionConfirmation',
        content: cellPhones.join().replace(/,/g, ' - '),
        isConfirmDelete: true,
        wordBreak: false,
        confirmByWritingText: true,
        isShowChip: true,
      });

      dialogResult
        .afterClosed()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((result) => {
          if (result) {
            this.callGroupDeletion();
            this.selectedIds = [];
            this.unCheckSelectAll();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
}
